<template>
  <div class='tag-handle'>
    <slot>
    H
    </slot>
  </div>
</template>

<script>
  export default {
    name: 'tag-handle',
    props: {
      resizeMode: {
        type: String
      }  
    },
    created() {
      // console.log('handle:created')
    },
    mounted() {
      // console.log('handle:mouted')
      this.initDND()
    },
    beforeDestroy() {
      // make sure to not have ghost event listeners hanging around
      // console.log('handle:beforeDeytroy')
      this.$el.removeEventListener('mousedown', this.onMouseDown)
      document.body.removeEventListener('mousemove', this.onMouseMove)
      document.body.removeEventListener('mousemove', this.onMouseUp)
    },
    methods: {
      initDND() {
        let el = this.$el
        this.pbb = this.$parent.$el.getBoundingClientRect()
        el.addEventListener('mousedown', this.onMouseDown)
      },
      onMouseDown(ev) {
        ev.preventDefault()
        ev.stopImmediatePropagation()
        document.body.addEventListener('mousemove', this.onMouseMove)
        document.body.addEventListener('mouseup', this.onMouseUp)
        this.$emit('startDrag', {
          cx: ev.clientX,
          cy: ev.clientY
        })
      },
      onMouseUp(ev) {
        document.body.removeEventListener('mousemove', this.onMouseMove)
        document.body.removeEventListener('mouseup', this.onMouseUp)
        this.$emit('endDrag', {
          cx: ev.clientX,
          cy: ev.clientY
        })
      },
      onMouseMove(ev) {
        let move = {}

        if (this.resizeMode === 'width') {
          move = {
            cx: ev.clientX, // probably need to take scrolss offset into account too
            rpx: ev.clientX - this.pbb.left,
            shiftKey: ev.shiftKey,
            ctrlKey: ev.ctrlKey,
            altKey: ev.altKey,
            resizeMode: 'width'
          }
        } else if (this.resizeMode === 'height') {
          move = {
            cy: ev.clientY,
            rpy: ev.clientY - this.pbb.top,
            shiftKey: ev.shiftKey,
            ctrlKey: ev.ctrlKey,
            altKey: ev.altKey,
            resizeMode: 'height'
          }
        } else {
          move = {
            cx: ev.clientX, // probably need to take scrolss offset into account too
            cy: ev.clientY,
            rpx: ev.clientX - this.pbb.left,
            rpy: ev.clientY - this.pbb.top,
            shiftKey: ev.shiftKey,
            ctrlKey: ev.ctrlKey,
            altKey: ev.altKey
          }
        }

        this.$emit('dragging', move)
      }
    }
  }

</script>
